<template>
  <div class="down-payment">
    <div class="title">首付款信息</div>
    <div class="pay-info">
      <p class="text">此笔分期您需支付首付款</p>
      <p class="price">¥{{ borrowInfo.downPayment || amount }}元</p>
    </div>
    <!-- *该笔首付款将由平台代收代付至成都华储卡电新能源科技有限公司（按最新需求隐藏） -->
    <!-- 下面白框（bank-info）按最新需求隐藏 -->

<!--      20260305yb首付款暂不走线上支付-->
<!--    <div class="result-btn">-->
<!--      <van-button round block color="#4D7BFE" class="btn" @click="toBorrow">-->
<!--        <span class="rem34">立即支付</span>-->
<!--      </van-button>-->
<!--    </div>-->

    <!--<div class="qr-pay">
      <p class="qr-tip">长按下方二维码跳转支付首付款</p>
      <img class="qr-img" :src="qrPayImg" alt="首付款支付二维码" />
      <van-button round block color="#4D7BFE" class="btn" @click="payTest">
        <span class="rem34">测试支付勿点</span>
      </van-button>
    </div>-->
      <div class="result-btn">
        <van-button round block color="#4D7BFE" class="btn" @click="addFstPayRecord">
          <span class="rem34">支付首付款</span>
        </van-button>
      </div>

    <!-- 支付确认弹窗 -->
    <van-popup v-model="show"  close-icon="close" :close-on-click-overlay="false"  class="pop-pay">
      <div class="popup-title">支付确认</div>
      <!-- 获取验证码 -->
      <div class="flex just-between rem30 lh21 mt30">
        <!-- <div class="c-4D7BFE mr16" @click="getVer">获取验证码</div> -->
        <van-field
          v-model="phoneCode"
          type="digit"
          placeholder="请输入短信验证码"
          maxlength="6"
        >
          <template #extra>
            <span class="rem30 c-4D7BFE" v-debounce="getCode">{{
              countDown == 0 ? '\u83b7\u53d6\u9a8c\u8bc1\u7801' : countDown + 's'
            }}</span>
          </template>
        </van-field>
      </div>
      <div class="line"></div>
      <div class="mt35">
        <van-button round block class="btn" color="#4D7BFE" v-debounce="confirm">
          <span class="rem34">确认</span>
        </van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Button, Popup, Divider, Field, Toast } from 'vant'
import { getSendCodeApi } from '@/apis/credit'
import { queryBillDetailApi, merchantRouteApi } from '@/apis/borrow'
import {sendFstPayCodeApi, addFstPayRecordApi, doFstPayApi, fstPayWxpayApi} from '@/apis/kdb'
import { getUserBindCardListApi, bankLimitApi } from '@/apis/repayment'
Vue.use(Button).use(Divider).use(Popup).use(Field)
import wx from 'weixin-js-sdk';


export default {
  name: 'downPayment',
  data() {
    return {
      show: false,
      codePng: require('@/assets/images/login/code.png'),
      countDown: 0,
      timerId: null,
      borrowInfo: {
        downPayment: '',
        lcApplAccInfoVO:{
          applAcNo: ''
        }
      },
      phoneCode: '',
      amount: 0,
      fstOpSeq: '',
      bankInfo: {},
      bankImgUrl: '',
      qrPayImg: require('@/assets/images/kdb/down-payment-qr.jpg'),
    }
  },
  created(){
    this.amount = this.$route.query.amount 
    this.queryBillDetailFun()
    //this.recordFstPayOnEnter()
  },
  methods: {
    getbankLimit(bankCode, merchantRoute){
      bankLimitApi({
        bankCode: bankCode,
        bindType: this.borrowInfo.daishouMerNoCode,
        businessCode: 'kdb',
        merchantRoute,
      }).then((res) => {
        this.bankInfo = res.data
        this.bankImgUrl = this.bankInfo.bankCode + '.png'
        try {
          this.bankImgUrl = require(`../../assets/images/bankCard/${this.bankImgUrl}`)
        } catch (e) {
          this.bankImgUrl = require(`../../assets/images/bankCard/bk_510.png`)
        }
      })
    },
    getMerchantRoute(){
      merchantRouteApi({
        companyCode: this.borrowInfo.daishouMerNoCode,
        businessType: 'kdb',
      }).then((res) => {
        if (res.code == 200) {
          let merchantRoute = res.data
          this.getUserBindCardList(merchantRoute)
        }
      })
    },
    // 获取银行卡信息
    getUserBindCardList(merchantRoute) {
      let param = { 
        bindType: this.borrowInfo.daishouMerNoCode,
        merchantRoute,
      };
      getUserBindCardListApi(param).then((res) => {
        // eslint-disable-next-line prefer-destructuring
        this.getbankLimit(res.data[0].bankCode, merchantRoute)
      })
    },
    changeBankCard(){
      this.$router.push({ path: '/changeBankCard', query: { type: 'downPayment' } })

      // this.$router.push({
      //   path: '/add-back-info',
      //   query: {
      //     bindType: this.borrowInfo.daishouMerNoCode,
      //     from: 'downPayment' // 绑卡以后还要回来20260305yb
      //   },
      // })
    },
    async queryBillDetailFun(){
      try {
        const { code, data, msg } = await queryBillDetailApi({
          loanNo: this.$store.state.borrow.loanNo,
          productCode: this.$store.state.common.productCode,
        })
        if (code == 200) {
          this.borrowInfo = data
          this.getMerchantRoute()
        }else{
          this.$common.toast(msg)
        }
      } catch (error) {
        this.$common.toast(error)
      }
    },
    // 获取验证码
    async getCode() {
      if (this.countDown > 0) return
      const loadingToast = Toast.loading({
        message: '发送中...',
        forbidClick: true,
        duration: 0,
      })
      sendFstPayCodeApi({
          loanNo: this.$store.state.borrow.loanNo,
      }).then( res => {
        if (res && res.code == 200) {
          this.fstOpSeq = res.data.fstOpSeq;
          loadingToast.clear()
          this.countDown = 60
          this.$common.toast('\u9a8c\u8bc1\u7801\u53d1\u9001\u6210\u529f')
          if (this.timerId) clearInterval(this.timerId)
          this.timerId = setInterval(() => {
            this.countDown--
            if (this.countDown == 0){
              this.codetext = '重新获取'
              clearInterval(this.timerId)
            }
          }, 1000)
        } else {
          this.$common.toast(res.msg)
        }
      })
    },
    onClose(){
        alert('关闭')
        return false
    },
    async confirm() {
      try {
        const { code, data, msg } = await doFstPayApi({
          loanNo: this.$store.state.borrow.loanNo,
          phoneCode: this.phoneCode,
          fstOpSeq: this.fstOpSeq
        })
        if(code === 200) {
          this.$router.push('/paymentResult')
        }else {
          this.$common.toast(msg)
        }
      } catch (error) {
        this.$common.toast(error)
      }
    },
    toBorrow() {
      this.getCode();
      this.show = true
    },
    async recordFstPayOnEnter() {
      try {
        const { code, msg } = await addFstPayRecordApi({
          loanNo: this.$store.state.borrow.loanNo
        })
        if (code !== 200) {
          this.$common.toast(msg)
        }
      } catch (error) {
        this.$common.toast(error)
      }
    },
    // 20260305yb首付款暂不走线上支付
    async addFstPayRecord() {
      // 旧逻辑暂时注释保留，不删除
      // try {
      //    const { code, data, msg } = await addFstPayRecordApi({
      //        loanNo: this.$store.state.borrow.loanNo
      //    })
      //     if(code === 200) {
      //             this.$router.push('/paymentResult')
      //         }else {
      //             this.$common.toast(msg)
      //    }
      // } catch (error) {
      //    this.$common.toast(error)
      // }
      const loanNo = this.$store.state.borrow.loanNo
      try {
        console.log('[downPayment] addFstPayRecord start', { loanNo })
        const { code, data, msg } = await addFstPayRecordApi({ loanNo })
        console.log('[downPayment] addFstPayRecord result', { code, status: data && data.status, msg })
        if (code !== 200) {
          this.$common.toast(msg)
          return
        }
        const status = data && data.status
        if (status === '200' || status === 200) {
          console.log('[downPayment] fst pay already success, go paymentResult', { loanNo })
          this.$router.push('/paymentResult')
          return
        }
        if (status === '100' || status === 100 || status === '150' || status === 150) {
          console.log('[downPayment] fst pay need wxpay flow', { loanNo, status })
          const wxRes = await fstPayWxpayApi({ loanNo })
          console.log('[downPayment] fstPayWxpayApi result', {
            code: wxRes && wxRes.code,
            status: wxRes && wxRes.data && wxRes.data.status,
            tradeState: wxRes && wxRes.data && wxRes.data.tradeState,
          })
          if (!wxRes || wxRes.code !== 200) {
            this.$common.toast(wxRes && wxRes.msg ? wxRes.msg : '微信支付发起失败')
            return
          }
          const wxData = wxRes.data || {}
          const wxStatus = wxData.status
          if (wxStatus === '200' || wxStatus === 200) {
            console.log('[downPayment] wxpay indicates success, go paymentResult', { loanNo })
            this.$router.push('/paymentResult')
            return
          }
          this.invokeWxPay(wxData)
          return
        }
        this.$common.toast(msg || '\u9996\u4ed8\u6b3e\u72b6\u6001\u5f02\u5e38')
      } catch (error) {
        console.error('[downPayment] addFstPayRecord exception', error)
        this.$common.toast(error)
      }
    },
    getVer() {},
    invokeWxPay(wxData = {}) {
      const appId = wxData.appId
      const timeStamp = wxData.timeStamp
      const nonceStr = wxData.nonceStr
      const packageValue = wxData.package || wxData.packageValue
      const signType = wxData.signType || 'RSA'
      const paySign = wxData.paySign
      if (!appId || !timeStamp || !nonceStr || !packageValue || !paySign) {
        console.warn('[downPayment] wxpay params missing', wxData)
        this.$common.toast('微信支付参数缺失')
        return
      }

      console.log('[downPayment] invoke wx pay', {
        appId,
        timeStamp,
        nonceStr,
        packageValue,
        signType,
      })
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        const redirectUrl = encodeURIComponent(`${window.location.origin}/paymentResult`)
        const url = '/pages/new/pay/jsapi/index'
          + `?appId=${encodeURIComponent(appId)}`
          + `&timestamp=${encodeURIComponent(timeStamp)}`
          + `&nonceStr=${encodeURIComponent(nonceStr)}`
          + `&package=${encodeURIComponent(packageValue)}`
          + `&paySign=${encodeURIComponent(paySign)}`
          + `&redirectUrl=${redirectUrl}`
          + `&signType=${encodeURIComponent(signType)}`
        console.log('[downPayment] miniProgram reLaunch', { url })
        wx.miniProgram.reLaunch({ url })
        return
      }

      if (typeof wx === 'undefined') {
        this.$common.toast('未检测到微信JS-SDK')
        return
      }

      wx.ready(() => {
        wx.chooseWXPay({
          appId,
          timestamp: String(timeStamp),
          nonceStr,
          package: packageValue,
          signType,
          paySign,
          success: (res) => {
            console.log('[downPayment] chooseWXPay success', res)
            this.$router.push('/paymentResult')
          },
          cancel: (res) => {
            console.warn('[downPayment] chooseWXPay cancel', res)
            this.$common.toast('\u5df2\u53d6\u6d88\u652f\u4ed8')
          },
          fail: (res) => {
            console.error('[downPayment] chooseWXPay fail', res)
            this.$common.toast('支付失败')
          },
        })
      })
      wx.error((err) => {
        console.error('[downPayment] wx sdk error', err)
        this.$common.toast('\u5fae\u4fe1\u652f\u4ed8\u521d\u59cb\u5316\u5931\u8d25')
      })
    },
    payTest(){
      if (typeof wx !== 'undefined' && wx.miniProgram) {
        let pack = encodeURIComponent("prepay_id=wx191159280124800f2f106bd6291edd0000");
        let appId = encodeURIComponent("wxbcf5f39dd385ff37");
        let timestamp = encodeURIComponent("1779163168");
        let nonceStr = encodeURIComponent("BTk4Q2eytGSyb6dEqYLYy1Xjd30TOKtm");
        let url = encodeURIComponent("https://test-kdbh5.mstdcc.com/downPayment");
        let paySign = encodeURIComponent("kio4klVWUeGnwMbihzptKY2F3nV7HL5cZQFmwOasYxbXeRdyNtis+2m8PsqNWq5dvWE4j1ThXuVxl7QzsFynh7kAkBGGkIWCF9CUT8SypvvAi7uqyQ+nCnI4EB/isjvmYTQkbp+MvlXIxO5nELTbqNRSeuSwVce113T7jNPTi3w+H/MWBis6fpf+wY5hwW7uYY6mJfcWsgRVH2olx9GGcNujXZs3jSJl2210V4YBOXnJtzRqaVCrYbfqVWXsw+qIRKlAeblGaFrqtN0jkH2/+ABuB6nr3ai+duew6DdpZqznLIyd48Qe0tN+BB6UP836GeMvJgOz64ldcIzZK7VBWw==");
        url = '/pages/new/pay/jsapi/index?appId='+appId+'&timestamp='+timestamp+'&nonceStr='+nonceStr+'&package='+pack+'&paySign='+paySign+'&redirectUrl='+url+'&signType=RSA'
        console.log(url)

        wx.miniProgram.reLaunch({
          url
        })
      }else {
        const { appId, timestamp, nonceStr, signature } = {appId: 'wxbcf5f39dd385ff37', timestamp: '1779095615', nonceStr: 'LX0Ax6gl1kHFhhh78qqblb6bD03qMib0', signature: 'LX0Ax6gl1kHFhhh78qqblb6bD03qMib0'};
        wx.config({
          debug: false, // 开启调试模式
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: ['chooseWXPay'] // 必填，需要使用哪个API就填哪个
        });
        wx.ready(() => {
          // config验证成功
          wx.chooseWXPay( {
            appId: "wxbcf5f39dd385ff37",     //公众号ID，由商户传入
            timestamp: "1779095615",     //时间戳，自1970年以来的秒数
            nonceStr: "LX0Ax6gl1kHFhhh78qqblb6bD03qMib0",      //随机串
            package: "prepay_id=wx181713355291517441a0d029bef3840001",
            signType: "RSA",     //微信签名方式：
            paySign: "m7tx703ed1pHYMA9aSTfl7x7VfvHlPoVmp8i0NDHHggIP9Mz47S+3ehkwDnHhuma6LChDJVpYJk6Wrh6yJ8iMRygkkGa2l7+Z6BkvDQ1hACoS0wD7v8H7t0Rg7+XDydwqtRZvkBbsumfv7ekT1Lq7CXEfWcYPZ6bob8hemHOTtkQCdF6Tr2jkw3VgWPxOGGgZ84VlgNYKJbaPK9u5EInI0GVGBK+PlJ1FDDDXMWPh5pdVmnNSj5lgfZWNS0L2Mn2qWLa2E1M9cohrSg6wzlDKEk/o0BbMDJ6fcmM0LtAlkfUPSdkcfCLstOYEScSey5KRs/2PmOH79QCtsUtE/vEaA==", //微信签名
            success: (res) => {
              // 支付成功
              if (res.errMsg === 'chooseWXPay:ok') {
                alert('支付成功');
              }
            },
            cancel: (res) => {
              // 用户取消支付
              alert('\u652f\u4ed8\u5df2\u53d6\u6d88');
            },
            fail: (res) => {
              // 支付失败
              console.error('支付失败:', res);
              alert('支付失败');
            }
          })
        });
        wx.error((err) => {
          // config验证失败
          console.error('微信JS-SDK初始化失败:', err);
        });
      }
    }
  },
}
</script>
<style scoped lang="less">
.down-payment {
  width: 100%;
  padding: 0.4rem;
  .title {
    margin-bottom: 0.3rem;
    font-weight: 500;
    font-size: 0.36rem;
    color: #333333;
    line-height: 0.5rem;
    font-style: normal;
  }
  .pay-info {
    width: 6.7rem;
    background: #ffffff;
    box-shadow: 0rem 0rem 0.3rem 0rem rgba(0, 0, 0, 0.08);
    border-radius: 0.08rem;
    padding: 0.96rem 0;
    text-align: center;
    margin-bottom: 0.26rem;
    .text {
      font-weight: 400;
      font-size: 0.36rem;
      color: #333333;
      line-height: 0.5rem;
      font-style: normal;
      margin-bottom: 0.52rem;
    }
    .price {
      font-weight: 500;
      font-size: 0.7rem;
      color: #e33232;
      line-height: 0.98rem;
      font-style: normal;
    }
  }
  .tip {
    width: 6.7rem;
    font-weight: 400;
    font-size: 0.24rem;
    color: #999999;
    line-height: 0.34rem;
    font-style: normal;
    margin-bottom: 0.3rem;
  }
  .bank-info {
    width: 6.7rem;
    background: #ffffff;
    box-shadow: 0rem 0rem 0.3rem 0rem rgba(0, 0, 0, 0.08);
    border-radius: 0.08rem;
    padding: 0.3rem 0;
    margin-bottom: 0.26rem;
    .bank-img {
      width: 0.7rem;
      height: 0.7rem;
      margin-left: 0.32rem;
      margin-right: 0.28rem;
    }
    .r-img {
      width: 0.5rem;
    }
  }
  .qr-pay {
    width: 6.7rem;
    margin-top: 0.3rem;
    text-align: center;
    .qr-tip {
      font-size: 0.28rem;
      color: #333333;
      line-height: 0.4rem;
      margin-bottom: 0.2rem;
    }
    .qr-img {
      width: 4.8rem;
      max-width: 100%;
      border-radius: 0.12rem;
      display: block;
      margin: 0 auto;
    }
  }
  .result-btn {
    position: absolute;
    margin-top: 0.82rem /* 41/50 */;
    bottom: 2.3rem;
    width: calc(100% - 0.84rem);
    .btn {
      margin-top: 0.48rem /* 24/50 */;
    }
  }

  .pop-pay {
    width: 75%;
    border-radius: 5px;
    padding: 0.52rem /* 26/50 */ 0.5rem /* 23/50 */;
    .popup-title {
      display: flex;
      justify-content: space-around;
      font-size: 0.38rem /* 19/50 */;
      line-height: 0.52rem /* 26/50 */;
      font-weight: 500;
    }
    .ipt {
      border: none;
    }
    .line {
      width: 100%;
      height: 0.01rem;
      background: #e1e1e1;
    }
    .btn {
      width: 2rem;
      margin: 0 auto;
    }
  }
}
/deep/ .van-cell {
  padding: 10px 0px /* 9/50 */;
}
</style>
